export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/el-ajansLogo.98fe3e30.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};